package navigation.settings

import com.essntl.core.utils.viewmodel.State
import com.essntl.features.profile.domain.model.ProfileModel

data class SettingsState(
    val getProfile: State<ProfileModel> = State(),
)